<template>
  <div class="page-container">
    <van-nav-bar
      fixed
      left-arrow
      :z-index="10"
      title="生日礼遇"
      @click-left="goableBack()"></van-nav-bar>
    <div class="view-bg">
      <div class="view-top">
        <!-- <div class="get-birthday-bg">
          <div
            :class="
              userInfo.nowIsBirthday ? 'get-birthday-btn' : 'get-birthday-gary'
            "
            @click="onGetBirthday">
            领取生日积分
          </div>
        </div> -->
      </div>
      <div class="birthday-list">
        <div class="birthday-rule-bg">
          <div class="title">{{ $route.params.descTitle }}</div>
          <div class="birthday-rule-content">
            {{ $route.params.descriptions }}
          </div>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>会员等级</th>
              <th>对应积分</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item of dataSource" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.score }}</td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>
      </div>
      <div class="page-action fy" style="padding-bottom: 0.5rem">
        <van-button
          @click="onGetBirthday"
          size="large"
          class="buy"
          :disabled="!userInfo.nowIsBirthday"
          >领取生日积分</van-button
        >
      </div>
    </div>
  </div>
</template>

<script >
import * as MemberIntegralApi from "@/api/memberIntegral"
import { Button } from "vant"
export default {
  components: {
    [Button.name]: Button
  },
  data() {
    return {
      dataSource: []
    }
  },
  created() {
    MemberIntegralApi.getBirthdayScoreConfig()
      .then((data) => {
        if (data) {
          this.dataSource = data
        }
      })
      .catch((e) => {
        this.$toast(e.msg || e.message)
      })
  },
  methods: {
    onGetBirthday() {
      if (this.userInfo.nowIsBirthday) {
        MemberIntegralApi.birthdaySendScore()
          .then((data) => {
            if (data) {
              this.$toast("领取成功，可以去积分明细查看喔～")
              this.userInfo.nowIsBirthday = false
            }
          })
          .catch((e) => {
            this.$toast(e.msg || e.message)
          })
      }
    }
  }
}
</script>

<style lang="less" scope>
.view-bg {
  background-image: url(../../assets/img/memberIntegral/mi_birthday_bg.png);
  background-repeat: no-repeat;
  background-size: 100%;
  margin-top: 0;
  .view-top {
    height: 170px;
    .get-birthday-bg {
      height: 100%;
      .get-birthday-gary,
      .get-birthday-btn {
        position: absolute;
        right: 24px;
        top: 17.5%;
        font-size: 14px;
        background-color: transparent;
      }
      .get-birthday-btn {
        color: rgb(238, 26, 32);
      }
      .get-birthday-gary {
        color: rgb(118, 118, 118);
      }
    }
  }
  .title {
    color: black;
    font-weight: 500;
    font-size: 18px;
    align-items: center;
    text-align: center;
    padding-top: 20px;
  }
  .birthday-list {
    // Firefox4.0-
    -moz-box-shadow: 2px 2px 10px rgb(212, 214, 211);
    // Safariand Google chrome10.0-
    -webkit-box-shadow: 2px 2px 10px rgb(212, 214, 211);
    // Firefox4.0+、Google Chrome 10.0+、Oprea10.5+ and IE9
    box-shadow: 2px 2px 10px rgb(212, 214, 211);
    margin: 15px;
    margin-bottom: 100px;
    padding-bottom: 5px;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
    .birthday-rule-bg {
      justify-content: center;
      justify-items: center;
      align-items: center;
      .birthday-rule-content {
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 20px;
        padding-bottom: 30px;
        color: rgb(80, 80, 80);
        font-size: 16px;
        font-weight: 500;
      }
    }
    table {
      margin: 0 30px;
      width: calc(100vw - 24vw);
      margin-bottom: 40px;
      th {
        padding: 8px 0;
        background-color: rgb(187, 205, 232);
        color: rgb(80, 82, 82);
        font-size: 18px;
        font-weight: 500;
        text-align: center;
      }
      td {
        color: rgb(110, 113, 113);
        font-size: 17px;
        font-weight: 500;
        height: 40px;
        text-align: center;
        // border-top: 1px solid rgb(234, 234, 234);
        border: 1px solid rgb(208, 225, 240);
      }
    }
  }
  .buy {
    background-color: #d6ae73;
    color: #ffffff;
    &.van-button--disabled {
      background-color: #d1d1d3;
      color: #ffffff;
      opacity: 1;
    }
  }
}
</style>